import * as yup from 'yup';

type MetricValue = string | number | boolean | null;
const isMetricValue = (value: unknown): value is MetricValue =>
  value === null ||
  typeof value === 'boolean' ||
  typeof value === 'string' ||
  (typeof value === 'number' && Number.isFinite(value));

export const reportRowSchema = yup
  .mixed<Record<string, MetricValue | Record<string, MetricValue>>>()
  .required()
  .test(
    'report-row',
    'Invalid Savings report row',
    (value) =>
      typeof value === 'object' &&
      value !== null &&
      !Array.isArray(value) &&
      Object.values(value).every(
        (item) =>
          isMetricValue(item) ||
          (typeof item === 'object' &&
            item !== null &&
            !Array.isArray(item) &&
            Object.values(item).every(isMetricValue))
      )
  );

export const reportResponseSchema = yup.object({
  data: yup.array(reportRowSchema).required()
});
export const managementFirmsSchema = yup.object({
  data: yup
    .array(
      yup.object({
        management_firm: yup.string().required(),
        partner_id: yup.string().required()
      })
    )
    .required()
});
export type SavingsReportRow = yup.InferType<typeof reportRowSchema>;
export type SavingsReportKind =
  | 'channel-metrics'
  | 'management-firm-metrics'
  | 'advisor-metrics';
export type SavingsReportRequest = {
  kind: SavingsReportKind;
  params: SavingsChannelParams | SavingsReportDateParams;
};
export type SavingsReportDateParams = {
  report_date?: string;
  management_firms?: string[];
};
export type SavingsChannelParams = {
  from: string;
  to: string;
  aggregation_period: string;
  management_firms: string[];
  include_direct: number;
};
